<template>
  <div
    v-if="showLoadingState == true"
    key="loadingState"
    >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="proyectosListado"
  >
    <div class="align-items-baseline display-flex-row">
      <form
        autocomplete="off"
        class="m-form-row m-form-search"
        name="simple-filters-form"
        @submit.prevent="readAcademia"
      >
        <AtomInputPrimary
          v-model="academia_url"
          :disabled="pagination.showLoadingState"
          v-on:keyup.enter="readAcademia"
          name="nombreProducto"
          placeholder="url de la academia"
          type="text"
          wrapperClass="a-input-wrapper-row"
        />
        <AtomSelectPrimary
          v-model.number="filtro.tipo"
          :disabled="pagination.showLoadingState"
          :elements="selectPrimary.tipo"
          keyField="id"
          name="tipoProducto"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="readAcademia"
        />
        <AtomSelectPrimary
          v-model.number="filtro.publicado"
          :disabled="pagination.showLoadingState"
          :elements="selectPrimary.publicado"
          keyField="id"
          name="publicadoProducto"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="readAcademia"
        />
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @resetFilter="resetFilter"
        />
      </form>
    </div>
    <div class="m-table-primary">
      <table>
        <tr v-show="proyectos.length">
          <th
            class="text-align-left"
            width="30%"
          >
            TÍTULO
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            ESTADO
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            FECHA ALTA
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            ÚLTIMA MODIF.
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
            TIPO
          </th>
          <!-- <th
            class="text-align-center"
            width="10%"
          >
            PREGUNTAS PEND.
          </th> -->
          <th
            class="text-align-center"
            width="10%"
          >
            VER
          </th>
        </tr>
        <tr
          v-for="proyecto in proyectos"
          :key="proyecto.id"
          class="row-data"
        >
          <td class="text-align-left">
            {{ proyecto.titulo }}
          </td>
          <td class="text-align-center">
            <span
              v-if="proyecto.publicado"
              class="font-weight-regular text-color-billing-primary"
            >
              Publicado
            </span>
            <span
              v-else
              class="font-weight-regular text-color-assets-primary"
            >
              Borrador
            </span>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(proyecto.fecha_alta).format('D MMM YYYY') }}
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(proyecto.fecha_modificacion).format('D MMM YYYY') }}
          </td>
          <td class="text-align-center">
            <span v-if="proyecto.tipo === 1">
              Mapa
            </span>
            <span v-else>
              Curso
            </span>
          </td>
          <!-- <td class="text-align-center">
            {{ proyecto.preguntas_sin_responder }}
          </td> -->
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.info"
              :element="proyecto.id"
              @goToProyectDetail="goToProyectDetail"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import configApp from '@/config'

export default {
  name: 'MoleculeEditionBillingAcademyProyects',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academia_url: '',

      buttonIconRounded: {
        info: {
          class: 'a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall',
          component: '',
          icon: 'far fa-file-alt',
          method: 'goToProyectDetail',
          tooltip: 'Informacion',
          type: 'button'
        }
      },

      buttonSecondary: {
        reset: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'resetFilter',
          text: '',
          tooltip: this.$t('mEditionBillingAcademyProducts.tooltip.restart'),
          type: 'button'
        }
      },

      filtro: {
        academia: '',
        tipo: '',
        publicado: '',
        pagina: 1,
        limite: 10
      },

      selectPrimary: {
        tipo: [
          {
            id: '',
            name: 'Todos los tipos'
          },
          {
            id: 0,
            name: 'Cursos'
          },
          {
            id: 1,
            name: 'Mapas'
          }
        ],
        publicado: [
          {
            id: '',
            name: 'Estado de publicación'
          },
          {
            id: 0,
            name: 'Borrador'
          },
          {
            id: 1,
            name: 'Publicado'
          }
        ]
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      proyectos: {},

      showLoadingState: true
    }
  },

  created () {
    this.academia_url = configApp.academyUrl
    this.readAcademia()
  },

  methods: {
    goToProyectDetail (proyectoId) {
      window.open(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.academyProyects.subject')}/${proyectoId}/${this.$t('mEditionMenu.billing.academyProyects.children.details.subedition')}`, '_blank')
    },

    readAcademia () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('academia', 'readAcademiaUrl', {}, [this.academia_url])
          .then(response => {
            this.filtro.academia = response.data.id
            this.readProyectos()
          })
          .catch(error => {
            this.showLoadingState = false
            this.pagination.showLoadingState = false
            this.$alerts.pushAlert('mEditionBillingAcademyProyects', 'readAcademy', 'error', 'a-alert-danger')
            console.log(error)
          })
      }
    },

    readProyectos () {
      this.$services.read('proyecto', 'readProyectos', {}, [], this.filtro)
        .then(response => {
          this.proyectos = response.data.proyectos
          console.log(response)

          this.pagination.currentQuantity = this.proyectos.length
          this.pagination.totalPages = response.data.paginas
          this.pagination.totalQuantity = response.data.total
          this.pagination.showLoadingState = false

          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    resetFilter () {
      this.academia_url = configApp.academyUrl
      this.filtro = {
        academia: '',
        tipo: '',
        publicado: '',
        pagina: 1,
        limite: 10
      }
      this.readAcademia()
    },

    setPaginationCurrentPage (page) {
      this.filtro.pagina = page
      this.pagination.currentPage = page
      this.pagination.showLoadingState = true
      this.readProyectos()
    }
  }
}
</script>
